module.exports = __webpack_public_path__ + "img/app-mdcm.b20660b5.webp";